import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hr-invoice-shell',
  templateUrl: './invoice-shell.component.html',
  styleUrls: ['./invoice-shell.component.less'],
  standalone: false,
})
export class InvoiceShellComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
